import { OfficeDetail as ContactOfficeDetailComponent } from '../../../../components/Contact';

export function TBMContactOfficeDetail() {
  return <ContactOfficeDetailComponent />;
}
